import React from 'react';

import { StyledStretchDiv } from '+/styledComponents/elements/containers';

import { Preferences } from './Preferences';

export const Settings = () => (
  <StyledStretchDiv>
    <Preferences />
  </StyledStretchDiv>
);
